/**
 * Öne çıkarılan (vitrin) ürünler — her biri için özel tanıtım sayfası (/yeni/:slug),
 * ana sayfada büyük tanıtım alanı ve üst şeritte duyuru.
 *
 * Yeni ürün eklemek: bu listeye bir kayıt ekleyin. Ürünün katalog kaydında da
 * "yeni": true ve "vitrin": "/yeni/<slug>" alanları olmalı.
 *
 * İçerik dört dilde; çevirisi olmayan dilde Türkçe gösterilir.
 * İkon adları: ates, simsek, alet, kova, kalkan, para (VitrinSayfasi.jsx'te eşleşir).
 */

export const VITRIN_URUNLERI = [
  {
    slug: "soguk-asfalt",
    urunId: "kovali-soguk-asfalt",
    gorsel: "/images/yapi-malzemeleri/soguk-asfalt/kovali-soguk-asfalt.webp",
    temsiliGorsel: true, // gerçek ürün fotoğrafı gelince false yapın
    // Miktar hesaplayıcı: 1 m² alanı 1 cm kalınlıkta (sıkıştırılmış) kaplamak için yaklaşık kg
    kgM2Cm: 23,
    kovaKg: 25, // kovanın net ağırlığı
    icerik: {
      tr: {
        ad: "Kovalı Soğuk Asfalt",
        slogan: "Çukuru ısıtmadan, makine olmadan onarın.",
        aciklama:
          "Kullanıma hazır soğuk asfalt: kapağı açın, çukura doldurun, sıkıştırın. Isıtma, karıştırma ya da özel ekipman gerekmez; onarılan yer kısa sürede yeniden kullanıma açılır.",
        serit: "Yeni: Kovalı Soğuk Asfalt mağazamızda — çukurları ısıtmadan onarın",
        avantajlar: [
          { ikon: "ates", baslik: "Isıtma gerektirmez", metin: "Soğuk uygulanır; asfalt kazanı, ocak ya da sıcak karışım beklemek yok." },
          { ikon: "simsek", baslik: "Kısa sürede kullanıma açılır", metin: "İyice sıkıştırıldıktan sonra yaya ve araç trafiğine hızla açılabilir." },
          { ikon: "alet", baslik: "Uygulaması kolay", metin: "Kürek ve tokmak yeterli; uzman ekip ya da iş makinesi gerekmez." },
          { ikon: "kova", baslik: "Kapaklı kova ambalaj", metin: "Taşıması kolay; artan malzemeyi kapağını kapatıp sonraki onarım için saklayın." },
          { ikon: "kalkan", baslik: "Sağlam ve uzun ömürlü", metin: "Doğru sıkıştırıldığında trafik altında sertleşir, çukuru sağlam şekilde doldurur." },
          { ikon: "para", baslik: "Ekonomik çözüm", metin: "Tüm yüzeyi yenilemek yerine yalnızca hasarlı bölgeyi onarın." },
        ],
        alanlar: [
          "Site ve fabrika içi yollar",
          "Otoparklar",
          "Garaj ve bahçe girişleri",
          "Akaryakıt istasyonları",
          "Rögar ve ızgara çevreleri",
          "Depo ve şantiye sahaları",
          "Okul, hastane ve AVM sahaları",
          "Belediye yol bakım çalışmaları",
        ],
        adimlar: [
          { baslik: "Temizleyin", metin: "Çukurdaki gevşek parçaları, tozu ve birikmiş suyu alın. Kenarlar sağlam olsun." },
          { baslik: "Doldurun", metin: "Malzemeyi yüzeyden biraz yüksek kalacak şekilde doldurun. Derin çukurlarda yaklaşık 3 cm'lik katlarla ilerleyin." },
          { baslik: "Sıkıştırın", metin: "El tokmağı, kompaktör ya da araç tekerleğiyle iyice sıkıştırın. Tokmağı ıslatmak yapışmayı önler." },
          { baslik: "Kullanıma açın", metin: "Yüzeye ince kum serpip onarılan yeri açın. Trafik altında sıkışmaya devam eder." },
        ],
        sss: [
          { soru: "Bir kova ne kadar alanı kaplar?", cevap: "Kalınlığa bağlıdır. Yaklaşık olarak 1 m² alanı 1 cm kalınlıkta kaplamak için 20–25 kg malzeme gerekir. Aşağıdaki hesaplayıcıyla çukurunuz için tahmini miktarı görebilirsiniz." },
          { soru: "Yağmurlu ya da soğuk havada uygulanır mı?", cevap: "Uygulamadan önce çukurdaki su mutlaka alınmalıdır. Soğuk havada malzeme sertleşirse kovayı kullanmadan önce bir süre ılık bir ortamda bekletin. Uygulama koşullarını mağazamızdan teyit edebilirsiniz." },
          { soru: "Artan malzemeyi saklayabilir miyim?", cevap: "Evet. Kovanın kapağını sıkıca kapatıp serin ve donmayan bir yerde saklayın." },
          { soru: "Hangi aletler gerekir?", cevap: "Kürek ya da mala ve sıkıştırmak için el tokmağı yeterlidir. Geniş alanlarda kompaktör işi hızlandırır; alet yoksa araç tekerleğiyle de sıkıştırılabilir." },
          { soru: "Toptan alımda fiyat avantajı var mı?", cevap: "Evet. Belediyeler, site yönetimleri ve müteahhitler için miktara göre özel fiyat veriyoruz. WhatsApp'tan yazın ya da toptan teklif formunu doldurun." },
        ],
        whatsapp: "Merhaba, Kovalı Soğuk Asfalt hakkında fiyat ve stok bilgisi almak istiyorum.",
      },
      en: {
        ad: "Cold Asphalt in a Bucket",
        slogan: "Repair potholes without heating or machinery.",
        aciklama:
          "Ready-to-use cold asphalt: open the lid, fill the hole, compact. No heating, mixing or special equipment; the repaired area is back in use quickly.",
        serit: "New: Cold Asphalt in a Bucket now in store — repair potholes without heating",
        avantajlar: [
          { ikon: "ates", baslik: "No heating needed", metin: "Applied cold — no asphalt boiler, burner or waiting for hot mix." },
          { ikon: "simsek", baslik: "Back in use quickly", metin: "Once well compacted, it can be opened to foot and vehicle traffic fast." },
          { ikon: "alet", baslik: "Easy to apply", metin: "A shovel and a tamper are enough — no specialist crew or machinery." },
          { ikon: "kova", baslik: "Resealable bucket", metin: "Easy to carry; close the lid and keep leftovers for the next repair." },
          { ikon: "kalkan", baslik: "Strong and durable", metin: "Properly compacted, it hardens under traffic and fills the hole firmly." },
          { ikon: "para", baslik: "Cost-effective", metin: "Repair only the damaged spot instead of resurfacing the whole area." },
        ],
        alanlar: [
          "Private and factory roads",
          "Car parks",
          "Garage and driveway entrances",
          "Fuel stations",
          "Around manholes and gratings",
          "Warehouse and site yards",
          "School, hospital and mall grounds",
          "Municipal road maintenance",
        ],
        adimlar: [
          { baslik: "Clean", metin: "Remove loose pieces, dust and standing water from the hole. Edges should be sound." },
          { baslik: "Fill", metin: "Fill slightly above the surface. For deep holes, work in layers of about 3 cm." },
          { baslik: "Compact", metin: "Compact firmly with a hand tamper, plate compactor or vehicle wheel. Wetting the tamper stops sticking." },
          { baslik: "Open", metin: "Dust the surface with fine sand and open the area. It keeps compacting under traffic." },
        ],
        sss: [
          { soru: "How much area does a bucket cover?", cevap: "It depends on thickness. Roughly 20–25 kg covers 1 m² at 1 cm thickness. Use the calculator below for an estimate for your hole." },
          { soru: "Can it be applied in rain or cold weather?", cevap: "Water must be removed from the hole first. If the material stiffens in cold weather, keep the bucket somewhere warm for a while before use. Please confirm application conditions with our store." },
          { soru: "Can I store leftovers?", cevap: "Yes. Close the lid tightly and store in a cool, frost-free place." },
          { soru: "Which tools do I need?", cevap: "A shovel or trowel and a hand tamper are enough. A plate compactor speeds up large areas; without tools a vehicle wheel can compact it." },
          { soru: "Is there a wholesale price?", cevap: "Yes. We offer volume pricing for municipalities, property managers and contractors. Message us on WhatsApp or fill in the wholesale quote form." },
        ],
        whatsapp: "Hello, I would like price and stock information for Cold Asphalt in a Bucket.",
      },
      fr: {
        ad: "Enrobé à Froid en Seau",
        slogan: "Réparez les nids-de-poule sans chauffer ni machine.",
        aciklama:
          "Enrobé à froid prêt à l'emploi : ouvrez le couvercle, remplissez le trou, compactez. Ni chauffage, ni mélange, ni équipement spécial ; la zone réparée est vite remise en service.",
        serit: "Nouveau : Enrobé à Froid en Seau en magasin — réparez sans chauffer",
        avantajlar: [
          { ikon: "ates", baslik: "Sans chauffage", metin: "S'applique à froid — pas de chaudière ni d'attente d'enrobé chaud." },
          { ikon: "simsek", baslik: "Remise en service rapide", metin: "Bien compacté, il peut être rouvert rapidement à la circulation." },
          { ikon: "alet", baslik: "Facile à appliquer", metin: "Une pelle et une dame suffisent — ni équipe spécialisée ni engin." },
          { ikon: "kova", baslik: "Seau refermable", metin: "Facile à transporter ; refermez et gardez le reste pour la prochaine réparation." },
          { ikon: "kalkan", baslik: "Solide et durable", metin: "Bien compacté, il durcit sous la circulation et comble le trou solidement." },
          { ikon: "para", baslik: "Économique", metin: "Réparez seulement la zone abîmée au lieu de refaire toute la surface." },
        ],
        alanlar: [
          "Voies privées et d'usine",
          "Parkings",
          "Entrées de garage et d'allée",
          "Stations-service",
          "Autour des regards et grilles",
          "Cours d'entrepôt et de chantier",
          "Écoles, hôpitaux, centres commerciaux",
          "Entretien des routes municipales",
        ],
        adimlar: [
          { baslik: "Nettoyer", metin: "Retirez les morceaux détachés, la poussière et l'eau stagnante. Les bords doivent être sains." },
          { baslik: "Remplir", metin: "Remplissez légèrement au-dessus de la surface. Pour les trous profonds, par couches d'environ 3 cm." },
          { baslik: "Compacter", metin: "Compactez avec une dame, une plaque vibrante ou une roue de véhicule. Mouiller la dame évite le collage." },
          { baslik: "Rouvrir", metin: "Saupoudrez de sable fin et rouvrez la zone. Le compactage continue sous la circulation." },
        ],
        sss: [
          { soru: "Quelle surface couvre un seau ?", cevap: "Cela dépend de l'épaisseur. Environ 20 à 25 kg couvrent 1 m² sur 1 cm. Utilisez le calculateur ci-dessous pour une estimation." },
          { soru: "Peut-on l'appliquer sous la pluie ou par temps froid ?", cevap: "L'eau doit d'abord être retirée du trou. Si le produit durcit par temps froid, placez le seau au chaud un moment avant usage. Confirmez les conditions d'application en magasin." },
          { soru: "Puis-je conserver le reste ?", cevap: "Oui. Refermez bien le couvercle et stockez au frais, à l'abri du gel." },
          { soru: "Quels outils faut-il ?", cevap: "Une pelle ou une truelle et une dame suffisent. Une plaque vibrante accélère les grandes surfaces ; sans outil, une roue de véhicule peut compacter." },
          { soru: "Y a-t-il un prix de gros ?", cevap: "Oui. Nous proposons des prix selon la quantité aux municipalités, syndics et entrepreneurs. Écrivez-nous sur WhatsApp ou remplissez le formulaire de devis." },
        ],
        whatsapp: "Bonjour, je souhaite connaître le prix et la disponibilité de l'Enrobé à Froid en Seau.",
      },
      ar: {
        ad: "أسفلت بارد في دلو",
        slogan: "أصلح الحفر دون تسخين ودون آلات.",
        aciklama:
          "أسفلت بارد جاهز للاستخدام: افتح الغطاء، املأ الحفرة، ثم اضغطها. لا حاجة إلى تسخين أو خلط أو معدات خاصة، ويعود المكان للاستخدام بسرعة.",
        serit: "جديد: أسفلت بارد في دلو متوفر في متجرنا — أصلح الحفر دون تسخين",
        avantajlar: [
          { ikon: "ates", baslik: "لا يحتاج إلى تسخين", metin: "يُطبَّق باردًا، دون غلاية أسفلت أو انتظار خلطة ساخنة." },
          { ikon: "simsek", baslik: "عودة سريعة للاستخدام", metin: "بعد الدكّ الجيد يمكن فتحه للمشاة والمركبات بسرعة." },
          { ikon: "alet", baslik: "سهل التطبيق", metin: "تكفي مجرفة ومدكّة، دون فريق متخصص أو آلات." },
          { ikon: "kova", baslik: "دلو بغطاء محكم", metin: "سهل الحمل؛ أغلق الغطاء واحتفظ بالباقي للإصلاح القادم." },
          { ikon: "kalkan", baslik: "متين وطويل العمر", metin: "عند دكّه جيدًا يتصلب تحت الحركة ويملأ الحفرة بثبات." },
          { ikon: "para", baslik: "حل اقتصادي", metin: "أصلح الجزء المتضرر فقط بدل تجديد السطح كله." },
        ],
        alanlar: [
          "طرق المجمعات والمصانع",
          "مواقف السيارات",
          "مداخل المرائب والحدائق",
          "محطات الوقود",
          "حول أغطية الصرف والشبكات",
          "ساحات المستودعات والمواقع",
          "ساحات المدارس والمستشفيات والمراكز التجارية",
          "صيانة الطرق البلدية",
        ],
        adimlar: [
          { baslik: "نظّف", metin: "أزل القطع المفككة والغبار والماء المتجمع. يجب أن تكون الحواف متينة." },
          { baslik: "املأ", metin: "املأ أعلى من السطح قليلًا. في الحفر العميقة اعمل بطبقات نحو 3 سم." },
          { baslik: "اضغط", metin: "اضغط جيدًا بمدكّة يدوية أو هزاز أو عجلة مركبة. ترطيب المدكّة يمنع الالتصاق." },
          { baslik: "افتح للاستخدام", metin: "انثر رملًا ناعمًا على السطح وافتح المكان. يستمر الدكّ تحت الحركة." },
        ],
        sss: [
          { soru: "ما المساحة التي يغطيها الدلو؟", cevap: "يعتمد على السماكة. تقريبًا 20–25 كغ تغطي 1 م² بسماكة 1 سم. استخدم الحاسبة أدناه لتقدير الكمية." },
          { soru: "هل يمكن تطبيقه في المطر أو البرد؟", cevap: "يجب إزالة الماء من الحفرة أولًا. إذا تصلب المنتج في البرد فاترك الدلو في مكان دافئ قليلًا قبل الاستخدام. تأكد من شروط التطبيق مع متجرنا." },
          { soru: "هل يمكن حفظ الباقي؟", cevap: "نعم. أغلق الغطاء بإحكام واحفظه في مكان بارد لا يتجمد." },
          { soru: "ما الأدوات اللازمة؟", cevap: "تكفي مجرفة أو مالج ومدكّة يدوية. الهزاز يسرّع العمل في المساحات الكبيرة، ويمكن الدكّ بعجلة مركبة عند عدم توفر الأدوات." },
          { soru: "هل يوجد سعر جملة؟", cevap: "نعم. نقدم أسعارًا حسب الكمية للبلديات وإدارات المجمعات والمقاولين. راسلنا على واتساب أو املأ نموذج عرض السعر." },
        ],
        whatsapp: "مرحبًا، أود معرفة سعر وتوفر الأسفلت البارد في دلو.",
      },
    },
  },
];

export const vitrinBul = (slug) => VITRIN_URUNLERI.find((v) => v.slug === slug);

/** Ürünün o dildeki içeriği; yoksa Türkçe */
export const vitrinIcerik = (vitrin, dil) => vitrin.icerik[dil] || vitrin.icerik.tr;
